export function makeDefaultRecord<T extends any>(
  defaultValGenerator: () => T
): Record<string, T> {
  return new Proxy({} as any, {
    get: (target, name) => {
      // we only proxy out string keys otherwise weird stuff happens
      if (!(name in target) && typeof name === 'string') {
        target[name] = defaultValGenerator()
      }
      return target[name]
    },
  })
}
